import notificationOff from "./notification/off.svg";
import favoriteOff from "./favorite/off.svg";
import favoriteOn from "./favorite/on.svg";
import profile from "./profile.svg";
import news from "./news.svg";
import orders from "./orders.svg";
import coins from "./coins.svg";
import addFilled from "./carbon_add-filled.svg";
import addFilledBlue from "./carbon_add-filled-blue.svg";
import chart from "./chart.svg";
import chartOff from "./chart-off.svg";
import chartOn from "./chartOn.svg";
import convert from "./convert.svg";
import btc from "./btc.svg";
import trade from "./trade.svg";
import walletOn from "./Wallet/on.svg";
import irt from "./IRT.svg";
import newsImg from "./news-img.png";
import power from "./power.svg";
import personIcon from "./person-icon.svg";
import arrowLeft from "./arrow-left.svg";
import filledHeart from "./filled-heart.svg";
import account from "./ic_account.svg";
import phone from "./phone.svg";
import key from "./key.svg";
import privacy from "./privacy.svg";
import instagram from "./instagram.svg";
import document from "./document.svg";
import errorCircle from "./error-circle.svg";
import arrowdown from "./arrowdown.svg";
import creditCard from "./credit-card.svg";
import supportPerson from "./support-person.svg";
import learning from "./learning.svg";
import guide from "./guide.svg";
import timer from "./timer.svg";
import history from "./history.svg";
import network from "./network.svg";
import coinsStack from "./coins-stack.svg";
import pasargad from "./pasargad.svg";
import arrowLeftLight from "./arrowleftlight.svg";
// Easy Trade
import tfavorite from "./easytrade/t-favorite.svg";
import tchart from "./easytrade/t-chart.svg";
import tnotif from "./easytrade/t-notif.svg";
import priceup from "./easytrade/priceup.svg";
import pricedown from "./easytrade/pricedown.svg";
import changeamount from "./easytrade/changeamount.svg";
import etIcon from "./easytrade/et-icon.svg";
import etInfo from "./easytrade/info-new.svg";
import etInfoGreen from "./easytrade/info-green.svg";
import infoBlue from "./easytrade/etInfoBlue.svg";
import arrowDownWhit from "./easytrade/arrow-down.svg";
import circleArrowRight from "./easytrade/circle-arrow.svg";
import circleArrowRightEn from "./easytrade/circle-arrow-en.svg";
import selectedTick from "./easyTether/coin-tick.svg";

import ada from "./ada.svg";
import success from "./receipt/success.svg";
import apps from "./sidebar/apps.svg";
import histories from "./sidebar/history.svg";
import BTC from "./crypto-icons/BTC.svg";
import ETH from "./crypto-icons/ETH.svg";
import BCH from "./crypto-icons/BCH.svg";
import TRX from "./crypto-icons/TRX.svg";
import USDT from "./crypto-icons/USDT.svg";
import IRT from "./crypto-icons/IRT.svg";
import DOGE from "./crypto-icons/DOGE.svg";
import BNB from "./crypto-icons/BNB.svg";
import ADA from "./crypto-icons/ADA.svg";
import arrowup from "./sidebar/arrow-up.svg";
import sidearrowdown from "./sidebar/arrow-down.svg";
import market from "./sidebar/markets.svg";
import sidprofile from "./sidebar/profile.svg";
import sideheart from "./sidebar/heart.svg";
import arrowfold from "./sidebar/arrow-fold.svg";
import arrowfoldEn from "./sidebar/arrow-fold-en.svg";
import dayMode from "./theme/dayMode.svg";
import nightMode from "./theme/nightMode.svg";
import info from "./easytrade/info.svg";
import copy from "./copy.svg";
import qrcode from "./qrcode.svg";
import qrcodeColored from "./qrcode-colored.svg";
import share from "./share.svg";
import roundInfo from "./roundInfo.svg";
import roundInfoYellow from "./roundInfo-yellow.svg";
import kycTrash from "./kycTrash.svg";
import kycVictory1 from "./kycVictory1.svg";
import kycLevel2panel from "./kycLevel2panel.svg";
import kycLevel3panel from "./kycLevel3Panel.svg";
import carbonwarning from "./carbon_warning.svg";
import settingarrow from "./setting-arrow.svg";
import easytradeoff from "./easytrade/off.svg";
import onNotif from "./onNotif.svg";
import dashboard from "./dashboard.svg";
import wallet from "./wallet.svg";
import markets from "./markets.svg";
import BTCWhite from "./crypto-icons/white/BTC-white.svg";
import TRXWhite from "./crypto-icons/white/TRX-white.svg";
import ETHWhite from "./crypto-icons/white/ETH-white.svg";
import DOGEWhite from "./crypto-icons/white/DOGE-white.svg";
import USDTWhite from "./crypto-icons/white/USDT-white.svg";
import BCHWhite from "./crypto-icons/white/BCH-white.svg";
import BNBWhite from "./crypto-icons/white/BNB-white.svg";

import noWallet from "./no-wallet.svg";
import noOrder from "./no-order.svg";
import noNotif from "./no-data-notif.svg";
import portfolioWallet from "./portfolio-wallet.svg";

import allTrade from "./all-trade.svg";
import sellTrade from "./sell-trade.svg";
import buyTrade from "./buy-trade.svg";
import inviteUser from "./invite-user.svg";
import setting from "./setting.svg";
import fluentLearning from "./fluent-learning.svg";
import arrowredleft from "./red-arrow-left.svg";
import arrowredleften from "./red-arrow-left-en.svg";
import addmoneysidebar from "./add-money-sidebar.svg";
import fluentSlideSearch from "./fluent-slide-search.svg";
import pageLoader from "./page-loader.svg";
import coinWithDraw from "./coin-withdraw-main-menu.svg";
import robotQRCode from "./robot-qrcode.svg";

// Easy Tether Landing
import shibaIcon from "./easyTether/Shiba.svg";
import kioskType from "./easyTether/kiosk-logo-typo.svg";
import easyTetherBg from "./easyTether/easy-tether-back.svg";
import boxArrow from "./easyTether/box-arrow.svg";
import boxArrowWhite from "./easyTether/box-arrow-white.svg";
import boxArrowWhiteRight from "./easyTether/box-arrow-right.svg";
import boxArrowWhiteRightEn from "./easyTether/box-arrow-right-en.svg";
import bestPrice from "./easyTether/best-price.svg";
import easyTradable from "./easyTether/easy-tradable.svg";
import fastCashOut from "./easyTether/fast-cashout.svg";
import questionCircle from "./easyTether/question-circle.svg";
import etArrowLeft from "./easyTether/ep-arrow-left.svg";
import supportIcon from "./easyTether/support-icon.svg";
import hambMenu from "./easyTether/hamburger-menu.svg";
import tetherIcon from "./easyTether/tether-form-icon.svg";
import helpInfo from "./easyTether/help-info.svg";
import loaderIcon from "./easyTether/loader.svg";
import receiptSuccess from "./easyTether/receipt-success.svg";
import receiptFailed from "./easyTether/receipt-fail.svg";
import refreshBalance from "./easyTether/refresh-balance.svg";
import loggedInUser from "./easyTether/loged-user.svg";
import loadingGif from "./easyTether/loading.gif";
import closeIcon from "./easyTether/close-ham.svg";
import logOutTether from "./easyTether/logout-tether.svg";
// sort icons
import ascDeactive from "./sort/ascending-deactive.svg";
import ascActive from "./sort/ascending-active.svg";
import desDeactive from "./sort/descending-deactive.svg";
import desActive from "./sort/descending-avtive.svg";

import kycNationalIdHolder from "./kyc/kyc-nationalid-holder.png";
import kycNationalIdHolderEn from "./kyc/kyc-nationalid-holder-en.png";

import sun from "./sun.svg";
import moon from "./moon.svg";
import greenCheckCircle from "./green-check-circle.svg";

// logos
import mainLogo from "./logo/main-logo.svg";
import mainLogoEn from "./logo/main-logo-en.svg";
import wiredLogo from "./logo/wired-logo.svg";

import search from "./search.svg";
import greenFace from "./green-face.svg";
import longRighArrow from "./long-right-arrow.svg";

import transactionReward from "./transaction/transaction-reward.svg";
import transactionDeposit from "./transaction/transaction-deposit.svg";
import transactionWithdraw from "./transaction/transaction-withdraw.svg";
import kycHelp from "./kyc-help.svg";
import logoWithName from "./logo-with-name.svg";
import creditHolder from "./credit-holder.svg";
import creditHolderEn from "./credit-holder-en.svg";
import closeCircle from "./close-circle.svg";
import shield from "./shield.svg";

// kyc
import kycFirst from "./kyc/kyc-first.png";
import kycSupport from "./kyc/kyc-support.svg";
import kycArrowRight from "./kyc/kyc-arrow-right.svg";
import kycSupportWhite from "./kyc/kyc-support-white.svg";
import kycWarning from "./kyc/kyc-warning.png";
import kycCode from "./kyc/kyc-code.svg";
import kycSelfieFrame from "./kyc/kyc-selfie-frame.svg";
import kycArrowLeft from "./kyc/kyc-arrow-left.svg";
import kycArrowLeftEn from "./kyc/kyc-arrow-left-en.svg";
import kycArrowLeftBlack from "./kyc/kyc-arrow-left-black.svg";
import kycShare from "./kyc/kyc-upload.svg";
import kycWarningGreen from "./kyc/kyc-warning-green.png";
import kycBookmark from "./kyc/kyc-bookmark.svg";
import kycVictory from "./kyc/kyc-victory.svg";
import kycLevelPassed from "./kyc/kyc-level-passed.svg";
import kycLevelRejected from "./kyc/kyc-level-rejected.svg";
import kycLevelWaiting from "./kyc/kyc-level-waiting.svg";
import kycArrowDown from "./kyc/kyc-arrow-down.svg";
import kycUploadCloud from "./kyc/kyc-upload-cloud.svg";
import kycPhone from "./kyc/kyc-phone.svg";
import kycLocation from "./kyc/kyc-location.svg";
import kycCircleArrow from "./kyc/kyc-circle-arrow.svg";

// login
import loginTime from "./login/login-time.svg";
import loginArrow from "./login/login-arrow.svg";
import loginCoin from "./login/login-coin.svg";

import gem from "./gem.svg";
import arrowBottomBlue from "./arrow-bottom-blue.svg";
import arrowRightBlue from "./arrow-right-blue.svg";
import arrowRightBlueEn from "./arrow-right-blue-en.svg";
import logout from "./logout.svg";
import inviteBanner from "./invite-baner.svg";
import kycMan from "./kyc/kyc-man.png";
import kycWoman from "./kyc/kyc-woman.png";

//collateral
import shieldDone from "./shield-done.svg";
import shieldDoneFilled from "./shield-done-filled.svg";
import shieldDoneRound from "./shield-done-round.svg";
import lendoBanner from "./lendoBanner.png";
import cartTwoTone from "./cart-two-tone.svg";
import arrowLeftCircle from "./arrow-left-circle.svg";
import LendoLogo from "./lendo.svg";
import UnionSepah from "./Union-64.svg";

import languageBtn from "./language-button.svg";
import iranFlag from "./iran-flag-round-circle-icon.svg";
import ukFlag from "./uk-flag-round-circle-icon.svg";

const icon = {
  ukFlag,
  iranFlag,
  languageBtn,
  notificationOff,
  profile,
  favoriteOff,
  favoriteOn,
  orders,
  news,
  coins,
  addFilled,
  chart,
  btc,
  chartOff,
  chartOn,
  trade,
  convert,
  irt,
  newsImg,
  power,
  personIcon,
  arrowLeft,
  filledHeart,
  account,
  phone,
  key,
  privacy,
  instagram,
  document,
  errorCircle,
  arrowdown,
  creditCard,
  supportPerson,
  learning,
  guide,
  timer,
  history,
  network,
  coinsStack,
  pasargad,
  arrowLeftLight,
  tfavorite,
  tchart,
  tnotif,
  priceup,
  pricedown,
  changeamount,
  ada,
  success,
  apps,
  histories,
  BTC,
  ETH,
  BCH,
  TRX,
  USDT,
  arrowup,
  market,
  sidprofile,
  sideheart,
  arrowfold,
  arrowfoldEn,
  sidearrowdown,
  IRT,
  dayMode,
  nightMode,
  info,
  copy,
  qrcode,
  share,
  roundInfo,
  kycTrash,
  kycVictory1,
  kycLevel2panel,
  kycLevel3panel,
  carbonwarning,
  settingarrow,
  easytradeoff,
  DOGE,
  onNotif,
  dashboard,
  wallet,
  markets,
  BTCWhite,
  TRXWhite,
  ETHWhite,
  DOGEWhite,
  USDTWhite,
  BCHWhite,
  noWallet,
  noOrder,
  portfolioWallet,
  allTrade,
  sellTrade,
  buyTrade,
  inviteUser,
  setting,
  noNotif,
  fluentLearning,
  arrowredleft,
  arrowredleften,
  addmoneysidebar,
  fluentSlideSearch,
  pageLoader,
  BNB,
  ADA,
  ascDeactive,
  desDeactive,
  desActive,
  ascActive,
  kycNationalIdHolder,
  kycNationalIdHolderEn,
  sun,
  moon,
  greenCheckCircle,
  BNBWhite,
  mainLogo,
  mainLogoEn,
  search,
  greenFace,
  longRighArrow,
  transactionReward,
  transactionDeposit,
  transactionWithdraw,
  shibaIcon,
  kioskType,
  easyTetherBg,
  boxArrow,
  bestPrice,
  easyTradable,
  fastCashOut,
  etArrowLeft,
  questionCircle,
  supportIcon,
  hambMenu,
  tetherIcon,
  helpInfo,
  boxArrowWhite,
  loaderIcon,
  receiptSuccess,
  boxArrowWhiteRight,
  boxArrowWhiteRightEn,
  refreshBalance,
  receiptFailed,
  walletOn,
  loggedInUser,
  kycHelp,
  logoWithName,
  creditHolder,
  creditHolderEn,
  closeCircle,

  // kyc
  kycFirst,
  kycSupport,
  kycArrowRight,
  kycSupportWhite,
  kycWarning,
  kycCode,
  kycSelfieFrame,
  kycArrowLeft,
  kycArrowLeftEn,
  kycArrowLeftBlack,
  kycShare,
  kycWarningGreen,
  kycBookmark,
  kycVictory,
  loadingGif,
  kycLevelPassed,
  kycLevelRejected,
  kycLevelWaiting,
  closeIcon,
  logOutTether,
  etIcon,
  etInfo,
  arrowDownWhit,
  circleArrowRight,
  circleArrowRightEn,
  selectedTick,
  kycArrowDown,
  kycUploadCloud,
  kycPhone,
  kycLocation,
  shield,
  loginTime,
  loginArrow,
  loginCoin,
  kycCircleArrow,
  etInfoGreen,
  infoBlue,
  gem,
  arrowBottomBlue,
  arrowRightBlue,
  arrowRightBlueEn,
  logout,
  inviteBanner,
  wiredLogo,
  kycMan,
  kycWoman,
  coinWithDraw,
  addFilledBlue,
  shieldDone,
  shieldDoneFilled,
  shieldDoneRound,
  lendoBanner,
  cartTwoTone,
  arrowLeftCircle,
  LendoLogo,
  UnionSepah,
  qrcodeColored,
  robotQRCode,
  roundInfoYellow,
};
export default icon;
